module.exports = __webpack_public_path__ + "img/aParty_110523_J.6a34d733.jpg";